
const POINT_FEATURE_SIZE = 1;

// @dynamic
export class FeatureUtils {
  static makeFeatureCollection(...features:GeoJSON.Feature<GeoJSON.Polygon>[]):GeoJSON.FeatureCollection<GeoJSON.Polygon>{
    return {
      type:'FeatureCollection',
      features:features
    };
  }

  static makeSquareFeature(latlng: L.LatLng,size?:number): GeoJSON.Feature<GeoJSON.Polygon> {
    size = size || POINT_FEATURE_SIZE
    const w = latlng.lng - size/2;
    const e = latlng.lng + size/2;
    const n = latlng.lat + size/2;
    const s = latlng.lat - size/2;

    return FeatureUtils.makeSquareFeatureFromBounds(w,s,e,n);
  }

  static makeSquareFeatureFromBounds(w:number,s:number,e:number,n:number): GeoJSON.Feature<GeoJSON.Polygon> {
    const square = [[
      [w,n],
      [w,s],
      [e,s],
      [e,n],
      [w,n]
    ]];

    return {
      type: 'Feature',
      geometry: {
        type: 'Polygon',
        coordinates: square
      },
      properties: {
      }
    };
  }
}